import React from "react";
// import { Button } from "@mui/material";
import { CenteredModal, FeedbackModalContent, ZoomInstructions } from "./FAQSearch.style";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";

const MSL_ZOOM_MEETING_URL =
  'https://app.zoom.us/wc/83548320864/join?ref_from=launch&fromPWA=1&pwd=Bzw3yyGSmjP0VDZ4ebrevzgvDWZq9o.1&_x_zm_rtaid=HGuqD0IpSPanalys4Jw8vA.1774330839169.8692192c5e68d7995a97d9fd168f56b4&_x_zm_rhtaid=417';
const CLB_ZOOM_MEETING_URL =
  'https://app.zoom.us/wc/82970266015/join?ref_from=launch&pwd=JtxxCMLFOrsP0EZ3fVPbamzrBJJgoZ.1&_x_zm_rtaid=HotBC-csRJ-84diLS5ZpHQ.1779084213412.938a01c148d5fd3bcafbaabe8a8d1d4e&_x_zm_rhtaid=518&fromPWA=1';

const resolveZoomMeetingUrl = (routeParam) => {
  const routeKey = String(routeParam || '').toLowerCase();
  if (routeKey.includes('clb')) return CLB_ZOOM_MEETING_URL;
  return MSL_ZOOM_MEETING_URL;
};

const LIBFAQ_URL = 'https://libfaq.nus.edu.sg/#s-la-page-column-2';

const ZoomCallBox = ({
  open,
  onClose,
  disableStartCall = false,
  supportCallNumber = '6516 6949',
  disabledMessage = 'Call Assistant Coming Soon!',
  showPhonePrompt = true,
  showZoom = true,
  afterHoursMode = false,
  onStartCallClick = null
}) => {
  const { library: routeParam } = useParams();
  // const handleStartZoomMeetingCallback = async () => {
  //   try {
  //     // Option 1: Direct PMR access (simpler, no OAuth)
  //     const response = await axios.get(`${BACKEND_API_URL}/zoom-pmr`);
  //     const pmrUrl = response.data.pmr_url;
      
  //     // Open PMR in new window
  //     const newWindow = window.open(pmrUrl, '_blank');
  //     if (!newWindow) {
  //       alert('Please allow pop-ups to open the Zoom meeting, or use this link: ' + pmrUrl);
  //     }
      
  //     // Close modal after opening meeting
  //     setTimeout(() => onClose(), 300);
      
  //     // Option 2: Use OAuth flow (uncomment if you want tracking)
  //     // window.location.href = `${BACKEND_API_URL}/zoom-auth`;
  //   } catch (error) {
  //     console.error('Failed to get PMR URL:', error);
  //     alert('Failed to open Zoom meeting. Please try again or call 6516 2046 directly.');
  //   }
  // };

  // const handleStartZoomMeeting = () => {
  //   const meetingId = '83548320864';
  //   const password = '851261';
  
  //   // Strategy 1: Standard join URL — reliably passes the password
  //   // This opens Zoom desktop app if installed, or falls back to browser
  //   const standardUrl = `https://zoom.us/j/${meetingId}?pwd=${encodeURIComponent(password)}`;
  
  //   // Strategy 2: zoommtg:// deep link — directly launches Zoom app and auto-fills password
  //   const deepLinkUrl = `zoommtg://zoom.us/join?confno=${meetingId}&pwd=${password}&zc=0`;
  
  //   // Try deep link first (auto-fills password in app), fallback to standard URL
  //   const newWindow = window.open(deepLinkUrl, '_blank');
  
  //   // Small delay, then open standard URL as fallback for browser-only users
  //   setTimeout(() => {
  //     window.open(standardUrl, '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes');
  //   }, 1500);
  
  //   if (!newWindow) {
  //     alert(
  //       `Please allow pop-ups.\n\nMeeting ID: ${meetingId}\nPassword: ${password}\n\nOr use this link:\n${standardUrl}`
  //     );
  //   } else {
  //     setTimeout(() => onClose(), 3000);
  //   }
  // };

  const handleStartZoomMeeting = async () => {
    if (typeof onStartCallClick === 'function') {
      try {
        await onStartCallClick();
      } catch (err) {
        console.error('Failed to track Start Zoom Call click:', err);
      }
    }
    const zoomMeetingUrl = resolveZoomMeetingUrl(routeParam);
    const newWindow = window.open(zoomMeetingUrl, '_blank','width=1200,height=800,scrollbars=yes,resizable=yes');
    if (!newWindow) {
      alert(`Please allow pop-ups to open the Zoom meeting, or use this link: ${zoomMeetingUrl}. You may also call ${supportCallNumber}.`);
    }
    setTimeout(() => onClose(), 300);
  };

  return (
    <CenteredModal
      open={open}
      onClose={onClose}
      aria-labelledby="zoom-call-modal"
    >
      <FeedbackModalContent style={{ width: '350px', maxWidth: '90vw' }}>
        <ZoomInstructions variant="h6" fontFamily={'RobotoRegular'} style={{display: 'block',  textAlign: 'center' }}>
          <b>Need staff assistance urgently? </b>
        </ZoomInstructions>
        <ZoomInstructions variant="body2" fontFamily={'RobotoRegular'} style={{display: 'block', marginBottom: '16px', textAlign: 'center' }}>
          {afterHoursMode ? (
            <>
              <br />
              Our phone line is currently unavailable. Please submit your enquiry online:
              <br /><br />
              <a href={LIBFAQ_URL} target="_blank" rel="noopener noreferrer"
                style={{ color: '#1565C0', fontWeight: 'bold' }}>
                Submit enquiry via LibFAQ
              </a>
              <br />
            </>
          ) : showPhonePrompt ? (
            <>
              <br /> <u><b>Call {supportCallNumber}</b></u>
              <br />
              Or submit your enquiry online:{' '}
              <a href={LIBFAQ_URL} target="_blank" rel="noopener noreferrer"
                style={{ color: '#1565C0', fontWeight: 'bold' }}>
                LibFAQ
              </a>
              {showZoom && <><br />Or call our staff in a live zoom meeting below</>}
              <br />
            </>
          ) : (
            <>
              <br /> Reach our staff in a live Zoom meeting below <br />
            </>
          )}
          Thank you for your patience as we improve our digital front desk service.
        </ZoomInstructions>
        
        {/* <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginTop: '16px',
          marginBottom: '8px',
          padding: '12px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px'
        }}>
          <ZoomInstructions variant="caption" fontFamily={'RobotoRegular'} style={{fontWeight: 'bold', color: '#666' }}>
            Meeting Password (if prompted):
          </ZoomInstructions>
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#E30B5D',
            letterSpacing: '2px',
            padding: '8px 16px',
            backgroundColor: 'white',
            borderRadius: '4px',
            border: '2px solid #E30B5D',
            cursor: 'pointer',
            userSelect: 'all'
          }}
          onClick={(e) => {
            navigator.clipboard.writeText('851261');
            e.target.style.backgroundColor = '#e8f5e9';
            setTimeout(() => {
              e.target.style.backgroundColor = 'white';
            }, 500);
          }}
          title="Click to copy password">
            851261
          </div>
          <ZoomInstructions variant="caption" fontFamily={'RobotoRegular'} style={{fontSize: '0.7rem', color: '#999' }}>
            Click password to copy
          </ZoomInstructions>
        </div> */}

        {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '10px', flexDirection: 'column', alignItems: 'center' }}>
          <ZoomQrImage src={'zoomQRCode.png'} alt="Zoom QR Code" style={{ width: '200px', height: '200px' }} />
        </div> */}
        
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '10px' }}>
          {disableStartCall && (
            <ZoomInstructions variant="caption" fontFamily={'RobotoRegular'} style={{ display: 'block', textAlign: 'center', marginBottom: '8px', color: '#E30B5D', fontWeight: 'bold' }}>
              {disabledMessage}
            </ZoomInstructions>
          )}
        </div>

        {showZoom && !afterHoursMode && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '0px', marginBottom: '10px' }}>
            <Button
              variant="contained"
              onClick={handleStartZoomMeeting}
              disabled={disableStartCall}
              style={{
                backgroundColor: disableStartCall ? '#9e9e9e' : '#E30B5D',
                color: 'white',
                padding: '10px 24px',
                fontWeight: 'bold',
                textTransform: 'none'
              }}
            >
              Start Zoom Call with Staff
            </Button>
          </div>
        )}
      </FeedbackModalContent>
    </CenteredModal>
  );
};

export default ZoomCallBox;
